export default __webpack_public_path__ + "static/media/white-book.ecb9ed13.png";